import React from "react";
import type { ICBLAnimationNG } from "../cbl-animationNG";
import { CBLAnimationNG } from "../cbl-animationNG";

export const CBLAnimationNGContext = React.createContext<ICBLAnimationNG>(
	null as unknown as ICBLAnimationNG,
);

interface ICBLAnimationNGProviderProps {
	children?: React.ReactNode | ((animationNG: ICBLAnimationNG) => React.ReactNode);
}

export const CBLAnimationNGProvider = (props: ICBLAnimationNGProviderProps) => {
	const animationNG = React.useMemo<ICBLAnimationNG>(() => new CBLAnimationNG(), []);
	return (
		<CBLAnimationNGContext.Provider value={animationNG}>
			{typeof props.children === "function" ? props.children(animationNG) : props.children}
		</CBLAnimationNGContext.Provider>
	);
};
